import { render } from "./TagsSelect.vue?vue&type=template&id=50dece0e&scoped=true"
import script from "./TagsSelect.vue?vue&type=script&lang=js"
export * from "./TagsSelect.vue?vue&type=script&lang=js"

import "./TagsSelect.vue?vue&type=style&index=0&id=50dece0e&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50dece0e"]])

export default __exports__